import { render, staticRenderFns } from "./DistributionOptionList.vue?vue&type=template&id=d432bc10&"
import script from "./DistributionOptionList.vue?vue&type=script&lang=js&"
export * from "./DistributionOptionList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports